module.exports = __webpack_public_path__ + "media/ambrascet_k.26f5ffbf.mp3";